/**
 * @generated SignedSource<<811c1fc94f69ad70a9aac4ce6fe24680>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationAdminServiceAccountsListItem_Store$data = {
  readonly serviceAccounts: ReadonlyArray<{
    readonly __typename: "ServiceAccount";
    readonly authTokens: ReadonlyArray<{
      readonly expiresAt: {
        readonly isoString: string;
      } | null;
    }>;
  }>;
  readonly " $fragmentType": "IntegrationAdminServiceAccountsListItem_Store";
};
export type IntegrationAdminServiceAccountsListItem_Store$key = {
  readonly " $data"?: IntegrationAdminServiceAccountsListItem_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminServiceAccountsListItem_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationAdminServiceAccountsListItem_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceAccount",
      "kind": "LinkedField",
      "name": "serviceAccounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ServiceAccountAuthToken",
          "kind": "LinkedField",
          "name": "authTokens",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StoreZonedDate",
              "kind": "LinkedField",
              "name": "expiresAt",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isoString",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "4e04d8f037d4be30f2d5ac9b20b8845c";

export default node;
